import { SkeletonWooDark } from '@/components/skeleton/skeleton.woo-dark';
import { type PinsProps } from '../-models/props';
import { WooEdit } from '@nosinovacao/fe-icons';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { Link } from '@tanstack/react-router';

export function PinsWooDark({ loading, pins, id }: Readonly<PinsProps>) {
  const { t } = useI18n();
  return (
    <div className="grid gap-3">
      <SkeletonWooDark className="h-[74px] rounded" count={3} loading={loading}>
        <div className="grid gap-3">
          {pins.map((p) => (
            <Link
              data-tid="link-edit-pin"
              to="/tv/$id/pins/$pin"
              params={{ pin: p.Type, id }}
              key={p.Type}
              className="grid grid-cols-[1fr_1.25rem] gap-x-2 rounded border border-nos-neutral-800 bg-nos-neutral-900 p-4"
            >
              <span
                data-tid="text-pin-type"
                className="font-light text-nos-neutral-200 font-text-p2"
              >
                {t(`Pins.Type.${p.Type}`)}
              </span>
              <div className="row-span-2 grid place-items-end">
                <WooEdit width={20} height={20} className="text-nos-neutral-400" />
              </div>
              <span data-tid="text-pin-code" className="font-bold text-nos-neutral-0 font-ui-8">
                {p.Code}
              </span>
            </Link>
          ))}
        </div>
      </SkeletonWooDark>
    </div>
  );
}
